const bolsa = (state = [], action) => {

    switch (action.type) {
        case 'FETCH_BOLSA': return action.bolsa
        case 'LOG_OUT': return []
        default: return state
    }
}

export const getBolsas = (state) => state
export const getBolsa = (state, id) => state.reduce((p, bolsa) => {
    if ( Number(bolsa.id) === Number(id)) return bolsa
    return p
}, {})

export default bolsa